module.exports = __webpack_public_path__ + "assets/img/course_240word.e731604d.png";